export const SAVED_EVENT="arcvault:saved";
export function notifySaved(message:string){
 window.dispatchEvent(new CustomEvent(SAVED_EVENT,{detail:message}));
}
